import { TipoDomandaDTO } from '@framework/api-client';
import { useAuth } from '@framework/auth';
import { InquiryItemBase } from '@framework/common-web';
import { useTranslation } from '@framework/i18n';
import { LinkButton } from '@framework/ui';
import React from 'react';
import { useLocation } from 'react-router';
import { CreateSubmissionButton } from '../../../../components/inquiries/list/CreateSubmissionButton';

export interface IInquiryItemProps {
  inquiry?: TipoDomandaDTO;
}

export function InquiryItem(props: IInquiryItemProps) {
  const { inquiry } = props;

  const { isLogged } = useAuth();

  const location = useLocation();
  const { t } = useTranslation();

  if (!inquiry) return null;

  return (
    <InquiryItemBase inquiry={inquiry}>
      {isLogged ? (
        <CreateSubmissionButton inquiry={inquiry} />
      ) : (
        <LinkButton
          type="primary"
          to={{ pathname: '/login', state: { from: location } }}
          block
          size="large"
        >
          {t('domanda-copertina.accedi', 'Accedi')}
        </LinkButton>
      )}
    </InquiryItemBase>
  );
}
